import React,{forwardRef} from 'react';
import { TextInput,Platform, Dimensions } from 'react-native';
import {useSuppressedInputRef} from '../../hooks/useKeyboardSuppression';

const DefaultInput = (props,ref) => {
  const width = Dimensions.get('window').width;
  // Opt-in: only dedicated scan fields suppress the software keyboard.
  const {setRef, suppressionProps} = useSuppressedInputRef(ref, !!props.suppressSoftwareKeyboard);
  let blurOnSubmit = window.navigator.platform === 'iPhone' || Platform.OS === 'ios' ? false : true
  let onSubmitCalled = false;
  const handleKeyPress = (e) =>{
    if(e.key === 'Enter'){
      if(width < 900 && !(window.navigator.platform === 'iPhone' || Platform.OS === 'ios')){
        props.onSubmitEditing();
        onSubmitCalled = true;
      }
    }
  }
  return(
    <TextInput
     testID={props?.testID || 'input'}
     ref={setRef}
     value={props.value}
     onChangeText={props.onChangeText}
     onSubmitEditing={()=>{
      !onSubmitCalled && props.onSubmitEditing()
     }}
     blurOnSubmit={blurOnSubmit}
     onFocus={props.onFocus}
     autoFocus={false}
     returnKeyType='done'
     placeholder={props.placeholder}
     placeholderTextColor={props.placeholderTextColor}
     onBlur={props.onBlur}
     autoCapitalize='none'
     onKeyPress={handleKeyPress}
     {...suppressionProps}
     style={props.style}
    />
  )
}
export default forwardRef(DefaultInput);
